var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-agree-check",on:{"click":function($event){return _vm.$emit('change', !_vm.checked)}}},[_c('MallCheckBox',{attrs:{"checked":_vm.checked}}),_vm._v(" "),_c('span',{staticClass:"mall-agree-check__label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c404c474","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/molecules/MallAgreeCheck.vue
// module id = null
// module chunks = 